import { cn, getListingHref, getTierClasses } from './listingCardUtils.js';

function getTextVariantTierClasses(tier = 'basic') {
  return {
    basic: {
      title: 'font-normal text-slate-950',
      hover: 'hover:underline',
    },
    featured: {
      title: 'font-normal text-[color:var(--listing-card-text,#0F172A)] underline',
      hover: 'hover:text-[color:var(--listing-card-primary-hover,#1D4ED8)]',
    },
    spotlight: {
      title: 'font-bold text-[color:var(--listing-card-primary,#2563EB)] underline',
      hover: 'hover:text-[color:var(--listing-card-accent,#F59E0B)]',
    },
  }[tier] || {
    title: 'font-normal text-slate-950',
    hover: 'hover:underline',
  };
}

function getChipVariantTierClasses(tier = 'basic') {
  return {
    basic: {
      title: 'font-semibold text-white',
      hover: 'hover:text-black group-hover/listing-chip:text-black',
    },
    featured: {
      title: 'font-semibold text-[color:var(--listing-card-primary-soft,#DBEAFE)]',
      hover: 'hover:bg-[color:var(--listing-card-primary-hover,#1D4ED8)]',
    },
    spotlight: {
      title: 'font-bold text-[color:var(--listing-card-accent,#F59E0B)]',
      hover: 'hover:bg-[color:var(--listing-card-primary-hover,#1D4ED8)]',
    },
  }[tier] || {
    title: 'font-semibold text-white',
    hover: 'hover:text-black group-hover/listing-chip:text-black',
  };
}

export default function ListingCardHeader({
  listing,
  variant = 'content',
  tier = 'basic',
  show = {},
}) {
  const tierClasses = getTierClasses(tier);
  const textTierClasses = getTextVariantTierClasses(tier);
  const chipTierClasses = getChipVariantTierClasses(tier);
  const href = getListingHref(listing);
  const titleClasses = cn(
    variant === 'directory' ? 'line-clamp-2' : 'truncate',
    variant === 'text' ? cn('text-sm', textTierClasses.title) : '',
    variant === 'chip' ? cn('block text-sm leading-5', chipTierClasses.title) : '',
    variant === 'row' ? 'text-sm font-semibold text-slate-950' : '',
    variant === 'directory' ? 'text-[17px] font-bold leading-6 text-slate-950' : '',
    variant !== 'text' && variant !== 'chip' ? 'font-semibold' : '',
    variant === 'hero' ? 'text-2xl text-white' : variant === 'text' || variant === 'chip' || variant === 'row' || variant === 'directory' ? '' : 'text-base text-slate-950',
  );

  const title = href ? (
    <a
      href={href}
      className={cn(
        titleClasses,
        variant === 'hero'
          ? 'hover:text-white/90'
          : variant === 'text'
            ? textTierClasses.hover
            : variant === 'chip'
              ? chipTierClasses.hover
              : variant === 'row'
                ? 'hover:text-[color:var(--listing-card-primary-hover,#1D4ED8)]'
                : variant === 'directory'
                  ? 'hover:text-[color:var(--listing-card-primary-hover,#1D4ED8)]'
                  : 'hover:underline',
      )}
    >
      {listing.name}
    </a>
  ) : (
    <span className={titleClasses}>{listing.name}</span>
  );

  if (variant === 'text') {
    return title;
  }

  if (variant === 'chip') {
    return title;
  }

  if (variant === 'row') {
    return title;
  }

  return (
    <div className="min-w-0">
      <div className="flex min-w-0 items-center gap-2">{title}</div>
      {show.category && listing.category ? (
        <p className={cn('mt-0.5 truncate text-sm', variant === 'hero' ? 'text-white/80' : variant === 'directory' ? 'text-xs text-slate-500' : tierClasses.accent)}>
          {listing.category}
        </p>
      ) : null}
    </div>
  );
}
